import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import './style/_legal.scss';

export default function Legal() {
  const kontentQuery = useStaticQuery(graphql`
  query{
    kontentItemLegal {
      elements {
        logo {
          value {
            url
          }
        }
        text {
          value
          name
          images {
            url
          }
          links {
            link_id
            url_slug
          }
        }
      }
    }
  }`);
  const kontent = kontentQuery.kontentItemLegal.elements;
  return (
    <div className="cic-footer-legal-container pt-4">
      <div className="cic-footer-legal mx-4">
        <div className='small-text-legal' dangerouslySetInnerHTML={{__html: kontent.text.value}}></div>
      </div>
    </div>
  )
}
